module.exports = __webpack_public_path__ + "img/procurador.b6ddde0b.png";